"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TBTC_crossChainContractsLoader, _TBTC_crossChainContracts;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBTC = void 0;
const deposits_1 = require("./deposits");
const maintenance_1 = require("./maintenance");
const redemptions_1 = require("./redemptions");
const contracts_1 = require("../lib/contracts");
const bitcoin_1 = require("../lib/bitcoin");
const ethereum_1 = require("../lib/ethereum");
const electrum_1 = require("../lib/electrum");
const base_1 = require("../lib/base");
/**
 * Entrypoint component of the tBTC v2 SDK.
 */
class TBTC {
    constructor(tbtcContracts, bitcoinClient, crossChainContractsLoader) {
        /**
         * Reference to the cross-chain contracts loader.
         */
        _TBTC_crossChainContractsLoader.set(this, void 0);
        /**
         * Mapping of cross-chain contracts for different supported L2 chains.
         * Each set of cross-chain contracts must be first initialized using
         * the `initializeCrossChain` method.
         */
        _TBTC_crossChainContracts.set(this, void 0);
        this.deposits = new deposits_1.DepositsService(tbtcContracts, bitcoinClient, (l2ChainName) => this.crossChainContracts(l2ChainName));
        this.maintenance = new maintenance_1.MaintenanceService(tbtcContracts, bitcoinClient);
        this.redemptions = new redemptions_1.RedemptionsService(tbtcContracts, bitcoinClient);
        this.tbtcContracts = tbtcContracts;
        this.bitcoinClient = bitcoinClient;
        __classPrivateFieldSet(this, _TBTC_crossChainContractsLoader, crossChainContractsLoader, "f");
        __classPrivateFieldSet(this, _TBTC_crossChainContracts, new Map(), "f");
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for Ethereum and Bitcoin mainnets.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin mainnet
     * @param signer Ethereum signer.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the signer's Ethereum network is other than
     *         Ethereum mainnet.
     */
    static async initializeMainnet(signer) {
        return TBTC.initializeEthereum(signer, contracts_1.Chains.Ethereum.Mainnet, bitcoin_1.BitcoinNetwork.Mainnet);
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for Ethereum Sepolia and Bitcoin testnet.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin testnet
     * @param signer Ethereum signer.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the signer's Ethereum network is other than
     *         Ethereum mainnet.
     */
    static async initializeSepolia(signer) {
        return TBTC.initializeEthereum(signer, contracts_1.Chains.Ethereum.Sepolia, bitcoin_1.BitcoinNetwork.Testnet);
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for the given Ethereum network and Bitcoin network.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin network.
     * @param signer Ethereum signer.
     * @param ethereumChainId Ethereum chain ID.
     * @param bitcoinNetwork Bitcoin network.
     * @param crossChainSupport Whether to enable cross-chain support. False by default.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the underlying signer's Ethereum network is
     *         other than the given Ethereum network.
     */
    static async initializeEthereum(signer, ethereumChainId, bitcoinNetwork, crossChainSupport = false) {
        const signerAddress = await (0, ethereum_1.ethereumAddressFromSigner)(signer);
        const tbtcContracts = await (0, ethereum_1.loadEthereumCoreContracts)(signer, ethereumChainId);
        let crossChainContractsLoader = undefined;
        if (crossChainSupport) {
            crossChainContractsLoader = await (0, ethereum_1.ethereumCrossChainContractsLoader)(signer, ethereumChainId);
        }
        const bitcoinClient = electrum_1.ElectrumClient.fromDefaultConfig(bitcoinNetwork);
        const tbtc = new TBTC(tbtcContracts, bitcoinClient, crossChainContractsLoader);
        // If signer address can be resolved, set it as default depositor.
        if (signerAddress !== undefined) {
            tbtc.deposits.setDefaultDepositor(signerAddress);
        }
        return tbtc;
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint with custom tBTC contracts and
     * Bitcoin client.
     * @param tbtcContracts Custom tBTC contracts handle.
     * @param bitcoinClient Custom Bitcoin client implementation.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @dev This function is especially useful for local development as it gives
     *      flexibility to combine different implementations of tBTC v2 contracts
     *      with different Bitcoin networks.
     */
    static async initializeCustom(tbtcContracts, bitcoinClient) {
        return new TBTC(tbtcContracts, bitcoinClient);
    }
    /**
     * Initializes cross-chain contracts for the given L2 chain, using the
     * given signer. Updates the signer on subsequent calls.
     *
     * @experimental THIS IS EXPERIMENTAL CODE THAT CAN BE CHANGED OR REMOVED
     *               IN FUTURE RELEASES. IT SHOULD BE USED ONLY FOR INTERNAL
     *               PURPOSES AND EXTERNAL APPLICATIONS SHOULD NOT DEPEND ON IT.
     *               CROSS-CHAIN SUPPORT IS NOT FULLY OPERATIONAL YET.
     *
     * @param l2ChainName Name of the L2 chain for which to initialize
     *                    cross-chain contracts.
     * @param l2Signer Signer to use with the L2 chain contracts.
     * @returns Void promise.
     * @throws Throws an error if:
     *         - Cross-chain contracts loader is not available for this TBTC SDK instance,
     *         - Chain mapping between the L1 and the given L2 chain is not defined.
     * @dev In case this function needs to support non-EVM L2 chains that can't
     *      use EthereumSigner as a signer type, the l2Signer parameter should
     *      probably be turned into a union of multiple supported types or
     *      generalized in some other way.
     */
    async initializeCrossChain(l2ChainName, l2Signer) {
        if (!__classPrivateFieldGet(this, _TBTC_crossChainContractsLoader, "f")) {
            throw new Error("Cross-chain contracts loader not available for this instance");
        }
        const chainMapping = __classPrivateFieldGet(this, _TBTC_crossChainContractsLoader, "f").loadChainMapping();
        if (!chainMapping) {
            throw new Error("Chain mapping between L1 and L2 chains not defined");
        }
        const l1CrossChainContracts = await __classPrivateFieldGet(this, _TBTC_crossChainContractsLoader, "f").loadL1Contracts(l2ChainName);
        let l2CrossChainContracts;
        switch (l2ChainName) {
            case "Base":
                const baseChainId = chainMapping.base;
                if (!baseChainId) {
                    throw new Error("Base chain ID not available in chain mapping");
                }
                l2CrossChainContracts = await (0, base_1.loadBaseCrossChainContracts)(l2Signer, baseChainId);
                break;
            default:
                throw new Error("Unsupported L2 chain");
        }
        __classPrivateFieldGet(this, _TBTC_crossChainContracts, "f").set(l2ChainName, Object.assign(Object.assign({}, l1CrossChainContracts), l2CrossChainContracts));
    }
    /**
     * Gets cross-chain contracts for the given supported L2 chain.
     * The given L2 chain contracts must be first initialized using the
     * `initializeCrossChain` method.
     *
     * @experimental THIS IS EXPERIMENTAL CODE THAT CAN BE CHANGED OR REMOVED
     *               IN FUTURE RELEASES. IT SHOULD BE USED ONLY FOR INTERNAL
     *               PURPOSES AND EXTERNAL APPLICATIONS SHOULD NOT DEPEND ON IT.
     *               CROSS-CHAIN SUPPORT IS NOT FULLY OPERATIONAL YET.
     *
     * @param l2ChainName Name of the L2 chain for which to get cross-chain contracts.
     * @returns Cross-chain contracts for the given L2 chain or
     *          undefined if not initialized.
     */
    crossChainContracts(l2ChainName) {
        return __classPrivateFieldGet(this, _TBTC_crossChainContracts, "f").get(l2ChainName);
    }
}
exports.TBTC = TBTC;
_TBTC_crossChainContractsLoader = new WeakMap(), _TBTC_crossChainContracts = new WeakMap();
//# sourceMappingURL=tbtc.js.map